import React from 'react';
import { Pie } from '@ant-design/charts';
import { Button, Modal } from 'antd';
import { connect } from 'react-redux';

const SubmitModal = ({
  studentAttendanceData,
  visible,
  okHandler,
  cancelHandler,
  presentStudentsArray,
  absentStudentsArray,
  selectedStudents, // Added from Redux
}) => {

  // ✅ Use selectedStudents from Redux as source of truth
  const totalStudents = studentAttendanceData?.length || 0;
  // Count how many students are marked present (true) in the map
  const presentCount = Object.values(selectedStudents || {}).filter(val => val === true).length;
  const absentCount = Math.max(totalStudents - presentCount, 0);

  // ✅ Debug (remove after verification)
  console.log({
    totalStudents,
    presentCount,
    absentCount,
    selectedStudents
  });

  const data = [
    { type: 'Present', value: presentCount },
    { type: 'Absent', value: absentCount },
  ];

  const config = {
    appendPadding: 10,
    data,
    angleField: 'value',
    colorField: 'type',
    // ✅ Fix: Use function to map specific type to specific color
    color: ({ type }) => {
      if (type === 'Present') return '#28DF99';
      return '#FF414D';
    },
    radius: 0.8,
    innerRadius: 0.68,
    autoFit: true,
    legend: false,
    label: {
      type: 'inner',
      content: '',
    },
    statistic: {
      title: false,
      content: {
        customHtml: () => (
          `<div style="text-align:center">
             <div style="font-size:20px;font-weight:700">${totalStudents}</div>
             <div style="font-size:10px;color:grey">Total Students</div>
           </div>`
        ),
      },
    },
  };

  const tags = ['Present', 'Absent'];
  const tagColors = ['#28DF99', '#FF414D'];

  return (
    <Modal
      className="modal-round-corner"
      visible={visible}
      onCancel={cancelHandler}
      footer={null}
      centered
      maskClosable
    >
      <div>
        {/* Header */}
        <div style={{ textAlign: 'center', marginTop: 25 }}>
          <div style={{ fontSize: 20, fontWeight: 'bold' }}>Confirm to Submit</div>
          <div style={{ fontSize: 16, color: '#636363' }}>
            Are you sure you want to submit attendance?
          </div>
        </div>

        {/* Pie Chart */}
        <div style={{ width: 280, margin: '20px auto' }}>
          <Pie style={{ height: 250 }} {...config} />
        </div>

        {/* Legend */}
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          {tags.map((tag, index) => (
            <div key={tag} style={{ display: 'flex', alignItems: 'center', marginRight: 15 }}>
              <div
                style={{
                  width: 15,
                  height: 15,
                  backgroundColor: tagColors[index],
                  borderRadius: 3,
                  marginRight: 5,
                }}
              />
              <div style={{ fontSize: 12, color: '#636363' }}>
                <span style={{ fontWeight: 'bold', fontSize: 14, color: '#191919' }}>
                  {tag === 'Present' ? presentCount : absentCount}
                </span>{' '}
                {tag}
              </div>
            </div>
          ))}
        </div>

        {/* Buttons */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: 25,
            marginBottom: 20,
          }}
        >
          <Button
            style={{
              backgroundColor: '#fff',
              borderRadius: 20,
              color: '#AEAEAE',
              borderColor: '#AEAEAE',
              minWidth: 120,
              marginRight: 20,
            }}
            onClick={cancelHandler}
          >
            NO
          </Button>

          <Button
            style={{
              backgroundColor: '#594099',
              borderRadius: 20,
              color: '#fff',
              minWidth: 120,
              marginLeft: 20,
            }}
            onClick={okHandler}
          >
            YES
          </Button>
        </div>
      </div>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  selectedStudents: state.schedule.selectedStudents,
});

export default connect(mapStateToProps)(SubmitModal);
